import { useMemo } from 'react';

import { getDirectoryByPluginId } from './PluginDirectoryMapping';
import { usePlugins } from './pluginsEntitiesSlice';
import { selectActivePlugins } from './pluginsService';
import type { PluginModule } from './registerPluginModule';
import { getPluginModule } from './registerPluginModule';
import type { ActivePlugin, Plugin, PluginProductCode } from './types';

type HookResult = {
    plugins: ActivePlugin[];
    error: unknown;
    isPending: boolean;
};

function enhancePlugin(plugin: Plugin): ActivePlugin {
    const module = getPluginModule(plugin.productCode) as PluginModule;
    const directory = getDirectoryByPluginId(plugin.productCode);

    return {
        imageUrl: `/${directory}/activated.svg`,
        ...plugin,
        ...module.config,
        getPluginCardActionButton: module.getPluginCardActionButton,
        PluginDeactivationInfo: module.PluginDeactivationInfo,
        PluginDeactivationSignInfo: module.PluginDeactivationSignInfo,
    };
}

export function useActivePlugins(): HookResult {
    const { isPending, error, allEntities: allPlugins } = usePlugins();

    const plugins = useMemo(() => selectActivePlugins(allPlugins).map(enhancePlugin), [allPlugins]);

    return {
        isPending,
        error,
        plugins,
    };
}

export function useActivePlugin(productCode: PluginProductCode): ActivePlugin | undefined {
    const { plugins } = useActivePlugins();
    return plugins.find((plugin) => plugin.productCode === productCode);
}
